export var normalizeBoolean = function (value) {
    if (typeof value === "boolean") {
        var promisified_1 = Promise.resolve(value);
        return function () { return promisified_1; };
    }
    return value;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-sdk/config-resolver/dist-es/endpointsConfig/utils/normalizeBoolean.js
// module id = 332
// module chunks = 0